import React from 'react';
import { Link } from 'react-router-dom';
import { Loader2Icon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'solid' | 'outline';
  to?: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
};

/* v5 pill button: solid = red neon gradient, outline = glass pill (styles in styles/ti-site.css). */
export function Button({
  children,
  variant = 'solid',
  to,
  type = 'button',
  onClick,
  disabled,
  loading,
  className = ''
}: ButtonProps) {
  const cls = `tis-btn sm ${variant === 'solid' ? 'solid' : ''} ${className}`;
  if (to) {
    return <Link to={to} className={cls} data-id="element-50" data-mp="28832xjmul8k2">
        {children}
      </Link>;
  }
  return <button type={type} onClick={onClick} disabled={disabled || loading} className={cls} data-id="element-51" data-mp="23at4xfle7okm">
      {loading && <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-52" data-mp="30rrvyunkctyn" />}
      {children}
    </button>;
}